import { render } from "./DeliveriesTemplate.vue?vue&type=template&id=fa73b630"
import script from "./DeliveriesTemplate.vue?vue&type=script&lang=js"
export * from "./DeliveriesTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__